{
	"backToManageDeclarations": "Wróć do: Zarządzaj deklaracjami",
	"kpi": {
		"quantity": "Ilość",
		"carbonSavings": "Redukcje emisji CO\u2082"
	},
	"downloadAllDeclarations": "Pobierz wszystkie deklaracje",
	"errors": {
		"notFound": "Nie znaleziono projektu"
	}
}
